import { releaseNotesSelectors } from '@sv-support-sdk/store';

export const {
  selectReleaseNotes,
  selectMeta,
  selectLoading,
  isReleaseNotesLoadedSelector,
  nextRequestParamsSelector,
} = releaseNotesSelectors;
